import React, { Component } from 'react';

import { GenericOption } from 'com-gyf-webcore-userinterfacecomponents';

import TagGrupo from './TagGrupo';

let groupsFound = undefined;
let groupPropKeyDescripcion = "Descripcion";
let keyWasPressed = false;

class BusquedaGrupoWindows extends Component {
    constructor(props) {
        super(props);

        this.state = {
            textGrupo: '',
            groupFound: true,
            showErrorMessage: false
        }
    }

    addGroup = (event) => {
        const { props } = this;

        let term = event.target.value.toString().toLowerCase();
        let showErrorMessage = false;
        let groupsFound = undefined;

        let groupsAdded = props.gruposWindowsSeleccionados.map(function (grupo) {
            return grupo.Descripcion;
        });

        let groups = props.gruposWindows.filter(function (grupo) {
            if (!props.gruposWindowsSeleccionados) {
                return grupo;
            }
            else {
                let index = groupsAdded.indexOf(grupo.Descripcion);
                if (index < 0) {
                    return grupo;
                }
            }
        });

        if (term != "") {
            showErrorMessage = true;
            term = term.replace("(", "").replace(")", "");
            //Descomentar o comentar si debe o no quitar los espacios de inicio y final en el string
            term = term.replace(/^\s+|\s+$/g, "");

            let terms = term.split(/\s/g);

            groupsFound = groups.filter(function (g) {
                let propDescripcion = (g[groupPropKeyDescripcion] || "").toString().toLowerCase();
                let descripciones = propDescripcion.split(/\s/g);

                if (!keyWasPressed) {
                    return (propDescripcion == term);
                } else {
                    if (descripciones.includes(term)) {
                        return true;
                    }
                }
            });
        }

        if (groupsFound && groupsFound.length == 1 && !keyWasPressed) {
            this.props.addGroupWindows(groupsFound[0].Id);

            this.setState({ textGrupo: '' });
        }
        else {
            this.setState({ textGrupo: event.target.value, groupFound: (groupsFound && groupsFound.length > 0), showErrorMessage });
        }

        keyWasPressed = false;
    }

    keyDown = (event) => {
        //backspace = 8, tab = 9, enter = 13, ctrol = 17, shift = 16, alt = 18, [left = 37, up = 38, rigth = 39, down = 40] (flechas)
        //=> no se deben considerar como tecla presionada

        let keyNotAllowed = [8, 9, 13, 16, 17, 18, 37, 38, 39, 40];

        if (keyNotAllowed.indexOf(event.keyCode) < 0) {
            keyWasPressed = false;
        }
    }

    onFocus = (event) => {
        keyWasPressed = false;
    }

    onKeyPress = (event) => {
        let regExp = /[a-z0-9]/ig;

        if (!regExp.test(event.key)) {
            event.preventDefault();
        }
    }

    render() {
        const { props } = this;

        let messageError = <label className="error zmdi-alert-circle">No se encontro el usuario buscado</label>;
        let showMessage = (!this.state.groupsFound && this.state.showErrorMessage);

        var oGroups = props.gruposWindows.map(function (grupo) {
            let result = props.gruposWindowsSeleccionados.find(function (g) {
                return (grupo.Descripcion == g.Descripcion);
            });

            return (
                <GenericOption id={grupo.Descripcion} descripcion={grupo.Descripcion} key={"Grupo_" + grupo.Descripcion} />
            );
        });

        var oGroupsName = props.gruposWindowsSeleccionados.map(function (grupo) {
            return (
                <TagGrupo id={grupo.Id} key={grupo.Id} descripcion={grupo.Descripcion} deleteGroupWindows={props.deleteGroupWindows} />
            );
        });

        return (
            <div className="row">
                <div className="col-xs-12">
                    <div className="row">
                        <div className="col-xs-12">
                            <div className="form-group bottom-separator-xs divisor-section" data-label="Grupos de windows a relacionar">
                                <label className="label-primary">Grupos de windows a relacionar</label>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12 search bottom-separator-xxs">
                            <span className="ti-search" style={{ top: 15, left: 25 }}></span>
                            <input list="groupsList" id="txtBusquedaDescripcion"
                                className="textbox-rectangular form-control default-input top-separator-xxxs bottom-separator-xxs"
                                value={this.state.textGrupo}
                                maxLength="40"
                                onChange={this.addGroup}
                                onKeyDown={this.keyDown}
                                onFocus={this.onFocus}
                                onKeyPress={this.onKeyPress}
                                placeholder="Buscar grupos por nombre..." />
                            <input id="textGrupo" type="hidden" />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-6">
                            <datalist id="groupsList">
                                {oGroups}
                            </datalist>
                        </div>
                        <div className="col-xs-12">
                            <ul id="groupsList" className="no-bullets no-margin-bottom">
                                {oGroupsName}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default BusquedaGrupoWindows;